module.exports = __webpack_public_path__ + "img/IPCGlobal-logo.0889df9.png";